import { useEffect } from "react";
import { Link } from "react-router-dom";
import MarketingShell from "@/components/marketing/MarketingShell";
import { ContactBlock } from "@/components/marketing/ContactBlock";

function Block({ b }) {
  if (b.list) return <ul className="list-disc pl-6 space-y-1.5 text-sm text-body leading-relaxed">{b.list.map((x, i) => <li key={i}>{x}</li>)}</ul>;
  if (b.defs) return <dl className="space-y-3">{b.defs.map(([term, def]) => <div key={term} className="text-sm leading-relaxed"><dt className="inline font-bold text-foreground">“{term}”</dt> <dd className="inline text-body">means {def}</dd></div>)}</dl>;
  return (
    <p className="text-sm text-body leading-relaxed">
      {b.p}{b.link && <> <Link to={b.link.to} className="font-semibold text-accent-700 hover:underline">{b.link.label}</Link>.</>}
    </p>
  );
}

export default function LegalPage({ meta, sections, testid, contactIntro }) {
  useEffect(() => { document.title = `${meta.title} | ChangeOS`; }, [meta.title]);
  return (
    <MarketingShell>
      <section className="max-w-6xl mx-auto px-6 pt-16 pb-10 border-b border-border-soft" data-testid={testid}>
        <div className="pp-overline">Legal</div>
        <h1 className="font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-3">{meta.title}</h1>
        <p className="text-lg text-subtle mt-3">{meta.sub}</p>
        <p className="text-sm text-muted-foreground mt-4" data-testid="legal-dates"><span className="font-semibold text-foreground">Effective Date:</span> {meta.effective} <span className="mx-2" aria-hidden="true">·</span> <span className="font-semibold text-foreground">Last Updated:</span> {meta.updated}</p>
      </section>
      <div className="max-w-6xl mx-auto px-6 py-12 grid lg:grid-cols-[260px_1fr] gap-12">
        <nav aria-label="Sections" className="hidden lg:block">
          <ol className="sticky top-24 space-y-1 text-sm max-h-[calc(100vh-8rem)] overflow-y-auto pr-2" data-testid="legal-toc">
            {sections.map((s, i) => <li key={s.id}><a href={`#${s.id}`} className="block rounded-lg px-3 py-1.5 text-subtle hover:text-foreground hover:bg-muted transition-colors"><span className="font-mono text-xs text-muted-foreground mr-2">{i + 1}.</span>{s.title}</a></li>)}
            <li><a href="#contact" className="block rounded-lg px-3 py-1.5 text-subtle hover:text-foreground hover:bg-muted transition-colors"><span className="font-mono text-xs text-muted-foreground mr-2">✉</span>Contact</a></li>
          </ol>
        </nav>
        <article className="max-w-3xl space-y-10">
          {sections.map((s, i) => (
            <section key={s.id} id={s.id} aria-labelledby={`${s.id}-h`} className="scroll-mt-24 space-y-4" data-testid={`legal-section-${s.id}`}>
              <h2 id={`${s.id}-h`} className="font-head text-lg md:text-xl font-extrabold tracking-tight"><span className="text-accent-600 mr-2">{i + 1}.</span>{s.title}</h2>
              {s.blocks.map((b, j) => <Block key={j} b={b} />)}
            </section>
          ))}
          <ContactBlock intro={contactIntro} />
        </article>
      </div>
    </MarketingShell>
  );
}
